// extracted by mini-css-extract-plugin
export default {"content-wrapper":"select-monitor-type_content-wrapper__9YEEa","content":"select-monitor-type_content__Ucs73"};